import { BaseModel } from "model/BaseModel";
import Usuario from "./Usuario";
import PessoaEndereco from "model/fiscal/PessoaEndereco";

export default class Pessoa implements BaseModel {

    id: number;
    codigo: string | null;
    codigoInterno: number;
    nome: string;
    tipo: string;
    tipoDocumento: string;
    numeroDocumento: string;
    usuarios: Usuario[];
    nomeFantasia: string | null = null;
    inscricaoEstadual: string | null = null;
    indicadorInscricaoEstadual: string | null = null;
    emailFiscal: string | null = null;
    identificacaoEstrangeira: string | null = null;
    consumidorFinalPadrao: boolean | null = null;
    enderecos: PessoaEndereco[] = [];

    constructor(
        id = 0,
        codigo = null,
        codigoInterno = 0,
        nome = '',
        tipo = '',
        tipoDocumento = '',
        numeroDocumento = '',
        usuarios = []
    ) {
        this.id = id;
        this.codigo = codigo;
        this.codigoInterno = codigoInterno;
        this.nome = nome;
        this.tipo = tipo;
        this.tipoDocumento = tipoDocumento;
        this.numeroDocumento = numeroDocumento;
        this.usuarios = usuarios;
    }
}
